(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-metaobject-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-faq-summary]');

    if (!summary) {
      return;
    }

    const root = summary.closest('[data-collection-faq]');

    if (!root || root.dataset.allowMultiple === 'true') {
      return;
    }

    const currentItem = summary.parentElement;

    root.querySelectorAll('.collection-metaobject-faq__item[open]').forEach((item) => {
      if (item !== currentItem) {
        item.removeAttribute('open');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyTypeDesktop = this.getAttribute('data-sticky-type-desktop') || 'none';
      this.stickyTypeMobile = this.getAttribute('data-sticky-type-mobile') || 'none';
      this.headerBounds = {};
      this.mobileBreakpoint = 750;

      this.updateStickyType();
      this.setHeaderHeight();

      // Listen for viewport changes - store bound references for cleanup
      this.onViewportChangeHandler = this.onViewportChange.bind(this);
      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
      this.mediaQuery = window.matchMedia(`(max-width: ${this.mobileBreakpoint - 1}px)`);
      this.mediaQuery.addEventListener('change', this.onViewportChangeHandler);
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeightHandler);

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    updateStickyType() {
      const isMobile = window.innerWidth < this.mobileBreakpoint;
      this.currentStickyType = isMobile ? this.stickyTypeMobile : this.stickyTypeDesktop;
      this.headerIsAlwaysSticky = this.currentStickyType === 'always' || this.currentStickyType === 'reduce-logo-size';
      this.stickyEnabled = this.currentStickyType !== 'none';

      // Update sticky class based on current viewport
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      } else if (!this.stickyEnabled) {
        this.header.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate');
      }
    }

    onViewportChange() {
      this.updateStickyType();
      // Re-evaluate scroll position with new settings
      this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.mediaQuery && this.onViewportChangeHandler) {
        this.mediaQuery.removeEventListener('change', this.onViewportChangeHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.stickyEnabled) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["independent-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-faq-summary]');

    if (!summary) {
      return;
    }

    const root = summary.closest('[data-independent-faq]');

    if (!root || root.dataset.allowMultiple === 'true') {
      return;
    }

    const currentItem = summary.parentElement;

    root.querySelectorAll('.independent-faq__item[open]').forEach((item) => {
      if (item !== currentItem) {
        item.removeAttribute('open');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["responsive-slideshow"] && !Shopify.designMode) return;
  try {
    
  class ResponsiveSlideshow {
    constructor(container) {
      this.container = container;
      this.slides = Array.from(container.querySelectorAll('[data-slide]'));
      this.dots = Array.from(container.querySelectorAll('[data-dot]'));
      this.prev = container.querySelector('[data-prev]');
      this.next = container.querySelector('[data-next]');
      this.index = 0;
      this.timer = null;
      this.autoplay = container.dataset.autoplay === 'true';
      this.interval = Number(container.dataset.interval) || 5000;
      this.startX = 0;
      this.startY = 0;
      this.isDragging = false;
      this.swiped = false;

      this.bind();
      this.start();
    }

    bind() {
      if (this.prev) {
        this.prev.addEventListener('click', () => this.show(this.index - 1));
      }

      if (this.next) {
        this.next.addEventListener('click', () => this.show(this.index + 1));
      }

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.show(Number(dot.dataset.dot)));
      });

      this.container.addEventListener('mouseenter', () => this.stop());
      this.container.addEventListener('mouseleave', () => this.start());
      this.container.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.container.addEventListener('pointerup', (event) => this.onPointerUp(event));
      this.container.addEventListener('pointercancel', () => this.onPointerCancel());
      this.container.addEventListener('click', (event) => this.onClick(event), true);
    }

    onPointerDown(event) {
      if (this.slides.length < 2 || event.pointerType === 'mouse') return;

      this.startX = event.clientX;
      this.startY = event.clientY;
      this.isDragging = true;
      this.swiped = false;
      this.stop();
    }

    onPointerUp(event) {
      if (!this.isDragging) return;

      const deltaX = event.clientX - this.startX;
      const deltaY = event.clientY - this.startY;
      const horizontalSwipe = Math.abs(deltaX) > 45;
      const mostlyHorizontal = Math.abs(deltaX) > Math.abs(deltaY) * 1.4;

      this.isDragging = false;

      if (horizontalSwipe && mostlyHorizontal) {
        this.swiped = true;
        this.show(deltaX < 0 ? this.index + 1 : this.index - 1);
      } else {
        this.start();
      }
    }

    onPointerCancel() {
      this.isDragging = false;
      this.start();
    }

    onClick(event) {
      if (!this.swiped) return;

      event.preventDefault();
      event.stopPropagation();
      this.swiped = false;
    }

    show(nextIndex) {
      if (this.slides.length === 0) return;

      this.index = (nextIndex + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.stop();
      this.start();
    }

    start() {
      if (!this.autoplay || this.slides.length < 2 || this.timer) return;
      this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  document.querySelectorAll('[data-responsive-slideshow]').forEach((container) => {
    new ResponsiveSlideshow(container);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanseking-description-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const classifyMedia = (image, card) => {
      if (!image.naturalWidth || !image.naturalHeight) return;
      if (image.naturalWidth / image.naturalHeight >= 1.35) {
        card.classList.add('sanseking-description-grid__media-card--wide');
      }
    };

    const enhanceDescription = (content) => {
      if (content.dataset.gridEnhanced === 'true') return;

      const directParagraphs = Array.from(content.querySelectorAll(':scope > p'));
      const mediaParagraph = directParagraphs.find((paragraph) => {
        return paragraph.querySelectorAll(':scope > img').length > 1 && paragraph.textContent.trim() === '';
      });

      if (!mediaParagraph) return;

      const firstParagraph = directParagraphs[0];
      const firstImages = firstParagraph ? firstParagraph.querySelectorAll(':scope > img') : [];
      const leadingNodes = [];
      let currentNode = content.firstElementChild;

      while (currentNode && currentNode !== mediaParagraph) {
        const nextNode = currentNode.nextElementSibling;
        leadingNodes.push(currentNode);
        currentNode = nextNode;
      }

      if (firstImages.length === 1 && leadingNodes.includes(firstParagraph)) {
        const intro = document.createElement('div');
        const announcement = document.createElement('div');
        const summary = document.createElement('div');
        const firstImage = firstImages[0];

        intro.className = 'sanseking-description-grid__intro';
        announcement.className = 'sanseking-description-grid__announcement';
        summary.className = 'sanseking-description-grid__summary';

        firstImage.remove();
        announcement.append(firstImage);

        leadingNodes.forEach((element) => {
          if (element.textContent.trim() || element.querySelector('img, video, iframe, table')) {
            summary.append(element);
          } else {
            element.remove();
          }
        });

        intro.append(announcement, summary);
        content.insertBefore(intro, mediaParagraph);
      }

      const mediaGrid = document.createElement('div');
      const images = Array.from(mediaParagraph.querySelectorAll(':scope > img'));
      mediaGrid.className = 'sanseking-description-grid__media-grid';

      images.forEach((image) => {
        const card = document.createElement('figure');
        card.className = 'sanseking-description-grid__media-card';
        card.append(image);
        mediaGrid.append(card);

        if (image.complete) {
          classifyMedia(image, card);
        } else {
          image.addEventListener('load', () => classifyMedia(image, card), { once: true });
        }
      });

      mediaParagraph.replaceWith(mediaGrid);
      content.dataset.gridEnhanced = 'true';
    };

    const initialize = (root) => {
      root.querySelectorAll('.sanseking-description-grid__content').forEach(enhanceDescription);
    };

    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
